/* ============================================================
   WESTSIDE BARBELL: PRODUCT FILTERING
   Replaces Boost. This is the old custom theme's category.js (Vue 2)
   rebuilt as plain JavaScript over this theme's own product cards.

   How it works
   - The server renders the first page of cards (see
     sections/wsbb-product-grid.liquid). Without JS, that page and its
     ?page= links are all the shopper gets, and it still works.
   - This script loads every product twice over, in parallel: the slim
     ?view=pfdata feed (just the filter data, JSON) and the ?view=cards
     feed (the cards themselves), 250 per request each. The sidebar is
     built from the data as soon as it arrives, which is well before the
     cards; a filter picked in between pulses the grid until the cards are
     in. Each card also carries its data in data-pf (snippets/wsbb-pf-data),
     which is the fallback if the data feed fails.
   - Filtering, sorting and paging all run in the browser, which is fine
     for a catalog of ~250 products. Cards are shown, hidden and reordered
     in place; nothing is rebuilt in JS.

   Behavior kept from the old theme
   - Groups: merchant tag groups (section "Product filter groups"), then
     Size, Brand (optional), Product Type, Price. A group shows only if it
     has two or more options. OR within a group, AND across groups.
   - Sorts: Featured, Highest/Lowest Price, A-Z, Z-A, Type, Brand; plus
     Best selling and Newest (Shopify's two standard sorts the old theme
     lacked). Newest is by created date; Best selling ranks come from the
     store-wide best-selling order of /collections/all, loaded when chosen.
   - URL: ?filters=Group:a,b;Group2:c&sort=…&pagination=N, written with
     replaceState, so old links still work.
   - localStorage: showCategoryFilters, mobileGridSize.
   - Load More, then infinite scroll after the first click.

   Deliberate changes
   - Tag-group lists split on commas or new lines and are trimmed, so the
     setting's formatting doesn't matter.
   - Only in-stock sizes are offered, as the old theme's variant-sizes
     snippet did. Spellings collapse (S/Small/small -> S, XXL/2XL -> 2XL) and
     sort XS -> 5XL.
   - Color matches variant colors as well as tags, since many products only
     have their colors as variants, and groups shades into families (Olive
     Drab -> Olive, Heather Red -> Red, Black Camo -> Camo).
   - Tag-group names that differ only by case, punctuation or a middle
     initial are one option (Mel C Siff / Mel Siff).
   - Tag-group options follow the order they're typed in the setting;
     Brand and Product Type are alphabetical.
   ============================================================ */
(function () {
  'use strict';

  var root = document.querySelector('[data-wsbb-pf]');
  if (!root || !window.fetch || !window.URL) return;

  function $(sel, el) { return (el || root).querySelector(sel); }
  function $$(sel, el) { return Array.prototype.slice.call((el || root).querySelectorAll(sel)); }
  function lower(s) { return String(s == null ? '' : s).trim().toLowerCase(); }

  var grid = $('[data-pf-grid]');
  var sidebar = $('[data-pf-sidebar]');
  var overlay = $('[data-pf-overlay]');
  var toggleBtn = $('[data-pf-toggle]');
  var sortSelect = $('[data-pf-sort]');
  var moreBtn = $('[data-pf-more-btn]');

  var perPage = parseInt(root.getAttribute('data-per-page'), 10) || 36;
  var loadMore = root.getAttribute('data-load-more') === 'true';
  var gridView = root.getAttribute('data-grid-view') || 'medium';
  var feedUrl = root.getAttribute('data-feed-url');
  var mobile = window.matchMedia('(max-width: 768px)');

  var config = { vendor: false, groups: [] };
  try { config = JSON.parse(document.getElementById('wsbb-pf-config').textContent); } catch (e) {}

  var PRICE_BUCKETS = [
    ['$0 - $49', 0, 4999], ['$50 - $99', 5000, 9999], ['$100 - $149', 10000, 14999],
    ['$150 - $199', 15000, 19999], ['$200 - $249', 20000, 24999], ['$250 - $299', 25000, 29999],
    ['$300 - $349', 30000, 34999], ['$350 - $399', 35000, 39999], ['$400 - $449', 40000, 44999],
    ['$450 - $499', 45000, 49999], ['$500+', 50000, null]
  ];

  // Sizes are entered inconsistently across products (S / Small / small,
  // XXL / 2XL…). Collapse the common spellings to one label so the Size filter
  // offers "S" once and matches all of them. Anything not listed (S/M,
  // Medium 17") keeps its own label.
  var SIZE_ALIASES = {
    'xxs': 'XXS', 'xx-small': 'XXS',
    'xs': 'XS', 'x-small': 'XS', 'extra small': 'XS',
    's': 'S', 'sm': 'S', 'small': 'S',
    'm': 'M', 'med': 'M', 'medium': 'M',
    'l': 'L', 'lg': 'L', 'large': 'L',
    'xl': 'XL', 'x-large': 'XL', 'xlarge': 'XL', 'extra large': 'XL',
    '2xl': '2XL', 'xxl': '2XL', 'xx-large': '2XL', '2x': '2XL',
    '3xl': '3XL', 'xxxl': '3XL', 'xxx-large': '3XL', '3x': '3XL',
    '4xl': '4XL', 'xxxxl': '4XL', '4x': '4XL',
    '5xl': '5XL', '5x': '5XL'
  };
  function canonicalSize(v) { return SIZE_ALIASES[lower(v)] || String(v).trim(); }
  var SIZE_ORDER = ['xxs', 'xs', 's', 's/m', 'm', 'm/l', 'l', 'l/xl', 'xl', '2xl', '3xl', '4xl', '5xl'];

  // Keys that decide when two option names are "the same":
  // - colors ignore case and treat gray/grey alike (Heather Gray = HEATHER GREY);
  // - other tag groups (authors…) ignore case, punctuation and middle initials,
  //   so "Mel C Siff" and "Mel Siff" are one option.
  function colorKey(v) { return lower(v).replace(/\s+/g, ' ').replace(/\bgray\b/g, 'grey'); }
  function nameKey(v) {
    return lower(v).replace(/[^a-z0-9\s]/g, ' ').split(/\s+/).filter(function (w) { return w.length > 1; }).join(' ');
  }
  // Color families. Shoppers filter by family, not exact shade, so each
  // color name joins the first family one of whose words it contains:
  // "Olive Drab" -> Olive, "Heather Red" -> Red, "Black Camo" -> Camo.
  // Order decides ties: patterns first (Black Camo is Camo, not Black), then
  // the more specific hues (Olive before Green, Tan before Brown). A name
  // that fits no family stays its own option. The family name is also its
  // swatch color (snippets/wsbb-color covers the ones CSS doesn't know).
  var COLOR_FAMILIES = [
    ['Camo', ['camo', 'camouflage']],
    ['Olive', ['olive']],
    ['Grey', ['grey', 'gray', 'charcoal', 'slate', 'silver']],
    ['Black', ['black']],
    ['White', ['white', 'cream', 'ivory', 'natural', 'bone']],
    ['Red', ['red', 'maroon', 'burgundy', 'crimson', 'cardinal']],
    ['Blue', ['blue', 'navy', 'royal', 'turquoise', 'teal']],
    ['Green', ['green', 'mint', 'fatigue', 'forest']],
    ['Tan', ['tan', 'khaki', 'sand', 'sandstone', 'beige']],
    ['Brown', ['brown']],
    ['Purple', ['purple']],
    ['Pink', ['pink']],
    ['Orange', ['orange']],
    ['Yellow', ['yellow']],
    ['Gold', ['gold']]
  ];
  function colorFamily(v) {
    var words = lower(v).split(/[^a-z]+/);
    for (var i = 0; i < COLOR_FAMILIES.length; i++) {
      var keys = COLOR_FAMILIES[i][1];
      for (var j = 0; j < keys.length; j++) if (words.indexOf(keys[j]) > -1) return COLOR_FAMILIES[i][0];
    }
    return titleCase(v);
  }
  function familyRank(f) {
    for (var i = 0; i < COLOR_FAMILIES.length; i++) if (COLOR_FAMILIES[i][0] === f) return i;
    return COLOR_FAMILIES.length;
  }

  function titleCase(v) {
    var t = String(v).trim();
    return t === t.toUpperCase() ? t.toLowerCase().replace(/\b[a-z]/g, function (c) { return c.toUpperCase(); }) : t;
  }

  var items = [];
  var byPos = {};
  var cardsReady = false;
  var groups = [];
  var state = { checked: {}, sort: '', page: 1 };
  var showFilters = readStore('showCategoryFilters') !== 'false';
  var mobileCols = readStore('mobileGridSize') === '1' ? 1 : 2;
  var infinite = false;

  function readStore(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function writeStore(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }

  /* ---------- Loading ---------- */

  // Cards use declarative shadow DOM (<template shadowrootmode>), which the
  // browser only attaches while parsing a page. setHTMLUnsafe attaches it for
  // markup parsed later; older browsers get the roots attached by hand.
  function parseHTML(html) {
    var box = document.createElement('div');
    if (box.setHTMLUnsafe) {
      box.setHTMLUnsafe(html);
    } else {
      box.innerHTML = html;
      attachShadowRoots(box);
    }
    return box;
  }

  function attachShadowRoots(scope) {
    scope.querySelectorAll('template[shadowrootmode]').forEach(function (t) {
      var host = t.parentNode;
      if (host && host.attachShadow && !host.shadowRoot) {
        var shadow = host.attachShadow({ mode: t.getAttribute('shadowrootmode') });
        shadow.appendChild(t.content);
        attachShadowRoots(shadow);
      }
      t.remove();
    });
  }

  function fetchFeedPage(n) {
    var url = new URL(feedUrl, location.origin);
    url.searchParams.set('page', n);
    return fetch(url.toString(), { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('feed ' + r.status);
      return r.text();
    }).then(parseHTML);
  }

  function loadAll() {
    return fetchFeedPage(1).then(function (first) {
      var feed = first.querySelector('[data-pf-feed]');
      var pages = feed ? parseInt(feed.getAttribute('data-pages'), 10) || 1 : 1;
      var rest = [];
      for (var n = 2; n <= pages; n++) rest.push(fetchFeedPage(n));
      return Promise.all(rest).then(function (others) { return [first].concat(others); });
    });
  }

  // The filter data, one JSON page at a time (templates/*.pfdata.liquid).
  function fetchDataPage(n) {
    var url = new URL(feedUrl, location.origin);
    url.searchParams.set('view', 'pfdata');
    url.searchParams.set('page', n);
    return fetch(url.toString(), { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('data ' + r.status);
      return r.json();
    });
  }

  function loadData() {
    return fetchDataPage(1).then(function (first) {
      var rest = [];
      for (var n = 2; n <= (first.pages || 1); n++) rest.push(fetchDataPage(n));
      return Promise.all(rest).then(function (others) {
        return [].concat.apply([], [first].concat(others).map(function (p) { return p.items || []; }))
          .filter(Boolean);
      });
    });
  }

  function dataOf(el) {
    try { return JSON.parse(el.getAttribute('data-pf')); } catch (e) { return null; }
  }

  function toItem(d) {
    if (!d) return null;
    return {
      el: null,
      id: d.h || 0,
      created: Number(d.n) || 0,
      pos: d.i || 0,
      title: String(d.t || ''),
      vendor: String(d.v || ''),
      type: String(d.y || ''),
      price: Number(d.p) || 0,
      tags: (d.g || []).map(String),
      tagsLower: (d.g || []).map(lower),
      tagNameKeys: (d.g || []).map(nameKey),
      colors: (d.c || []).map(String),
      sizesLower: (d.s || []).map(function (x) { return lower(canonicalSize(x)); }),
      sizes: (d.s || []).map(String)
    };
  }

  /* ---------- Filter groups ---------- */

  function sizeRank(s) {
    var i = SIZE_ORDER.indexOf(lower(s));
    if (i > -1) return i;
    var n = parseFloat(s);
    return isNaN(n) ? 1000 : 500 + n;
  }

  // Distinct values across items, keeping the first casing seen.
  function distinct(list) {
    var seen = {};
    var out = [];
    list.forEach(function (v) {
      var k = lower(v);
      if (k && !seen[k]) { seen[k] = true; out.push(String(v).trim()); }
    });
    return out;
  }

  function buildGroups() {
    var out = [];

    // Tag-group options exist only if some product carries the tag; keyed so
    // "Mel C Siff" and "Mel Siff" are one option.
    var tagByName = {};
    items.forEach(function (it) {
      it.tags.forEach(function (t) {
        var nk = nameKey(t);
        if (nk && !tagByName[nk]) tagByName[nk] = titleCase(t);
      });
    });

    var hasColorGroup = false;
    var blocks = config.blocks || (config.groups || []).map(function (g) { return { type: 'group', name: g.name, tags: g.tags }; });
    blocks.filter(function (b) { return b.type === 'group'; }).forEach(function (g) {
      if (!g.name) return;
      var isColor = /^colou?r$/i.test(g.name);
      var wanted = distinct(String(g.tags || '').split(/[\n,]+/));
      var options = [];
      var seen = {};

      if (isColor) {
        hasColorGroup = true;
        // An item's colors: its in-stock variant colors, plus any tag that is
        // one of the configured colors (items with no Color option are often
        // just tagged "Black"). Arbitrary tags aren't read as colors, so
        // "Black Friday" never lands in Black. Each color joins its family.
        var colorTags = {};
        wanted.forEach(function (w) { colorTags[colorKey(w)] = true; });
        var families = {};
        items.forEach(function (it) {
          var fams = {};
          it.colors.forEach(function (c) { fams[colorFamily(c)] = true; });
          it.tags.forEach(function (t) { if (colorTags[colorKey(t)]) fams[colorFamily(t)] = true; });
          it.colorFamilies = Object.keys(fams);
          it.colorFamilies.forEach(function (f) { families[f] = true; });
        });
        Object.keys(families)
          .sort(function (x, y) { return familyRank(x) - familyRank(y) || x.localeCompare(y); })
          .forEach(function (f) {
            options.push({ name: f, match: function (it) { return it.colorFamilies.indexOf(f) > -1; } });
          });
      } else {
        wanted.forEach(function (w) {
          var k = nameKey(w);
          if (!k || seen[k] || !tagByName[k]) return;
          seen[k] = true;
          options.push({ name: titleCase(w), match: function (it) { return it.tagNameKeys.indexOf(k) > -1; } });
        });
      }
      out.push({ key: g.name, label: g.name, kind: isColor ? 'color' : 'list', options: options });
    });

    // No Color group configured: still offer families from the variants.
    if (!hasColorGroup) {
      var fam = {};
      items.forEach(function (it) {
        it.colorFamilies = distinct(it.colors.map(colorFamily));
        it.colorFamilies.forEach(function (f) { fam[f] = true; });
      });
      out.unshift({ key: 'Color', label: 'Color', kind: 'color', options: Object.keys(fam)
        .sort(function (x, y) { return familyRank(x) - familyRank(y) || x.localeCompare(y); })
        .map(function (f) { return { name: f, match: function (it) { return it.colorFamilies.indexOf(f) > -1; } }; }) });
    }

    var sizes = distinct([].concat.apply([], items.map(function (it) { return it.sizes.map(canonicalSize); })));
    sizes.sort(function (a, b) { return sizeRank(a) - sizeRank(b) || a.localeCompare(b); });
    out.push({
      key: 'Size', label: 'Size', kind: 'size',
      options: sizes.map(function (s) {
        var k = lower(s);
        return { name: s, match: function (it) { return it.sizesLower.indexOf(k) > -1; } };
      })
    });

    if (config.vendor || blocks.some(function (b) { return b.type === 'brand'; })) {
      out.push(valueGroup('Vendor', 'Brand', 'vendor'));
    }
    out.push(valueGroup('Product Type', 'Product Type', 'type'));

    var priceOptions = [];
    PRICE_BUCKETS.forEach(function (b) {
      var min = b[1];
      var max = b[2];
      var inRange = function (it) { return it.price >= min && (max === null || it.price <= max); };
      if (items.some(inRange)) priceOptions.push({ name: b[0], match: inRange });
    });
    out.push({ key: 'Price', label: 'Price', kind: 'list', options: priceOptions });

    return ordered(out, blocks).filter(function (g) { return g.options.length > 1; });
  }

  // Sidebar order = the blocks' order in the theme editor ("Product filter
  // groups"). The built-in filters are placed and shown only via their blocks
  // once any of them has one; before that, the default order applies. Group
  // keys stay fixed (Size, Vendor…) so ?filters= links don't depend on labels.
  var BUILT_IN = { size: 'Size', brand: 'Vendor', product_type: 'Product Type', price: 'Price' };
  function ordered(groups, blocks) {
    if (!blocks.some(function (b) { return BUILT_IN[b.type]; })) return groups;
    var byKey = {};
    groups.forEach(function (g) { byKey[g.key] = g; });
    var out = [];
    blocks.forEach(function (b) {
      var g = byKey[b.type === 'group' ? b.name : BUILT_IN[b.type]];
      if (!g || out.indexOf(g) > -1) return;
      if (b.label) g.label = b.label;
      out.push(g);
    });
    // A Color group made from variants alone (no Color block) leads, as before.
    if (byKey.Color && out.indexOf(byKey.Color) < 0 && !blocks.some(function (b) { return b.type === 'group' && /^colou?r$/i.test(b.name); })) {
      out.unshift(byKey.Color);
    }
    return out;
  }

  function valueGroup(key, label, field) {
    var values = distinct(items.map(function (it) { return it[field]; }));
    values.sort(function (a, b) { return a.localeCompare(b); });
    return {
      key: key, label: label, kind: 'list',
      options: values.map(function (v) {
        var k = lower(v);
        return { name: v, match: function (it) { return lower(it[field]) === k; } };
      })
    };
  }

  /* ---------- Filtering, sorting, paging ---------- */

  function isChecked(groupKey, name) {
    return (state.checked[groupKey] || []).indexOf(name) > -1;
  }

  function activeCount() {
    return Object.keys(state.checked).reduce(function (n, k) { return n + state.checked[k].length; }, 0);
  }

  function filtered() {
    var active = groups.filter(function (g) { return (state.checked[g.key] || []).length; });
    var list = items.filter(function (it) {
      return active.every(function (g) {
        return g.options.some(function (o) { return isChecked(g.key, o.name) && o.match(it); });
      });
    });

    var by = {
      pricea: function (a, b) { return b.price - a.price; },
      priced: function (a, b) { return a.price - b.price; },
      atoz: function (a, b) { return a.title.localeCompare(b.title); },
      ztoa: function (a, b) { return b.title.localeCompare(a.title); },
      type: function (a, b) { return a.type.localeCompare(b.type); },
      vendor: function (a, b) { return a.vendor.localeCompare(b.vendor); },
      newest: function (a, b) { return b.created - a.created; },
      bestselling: function (a, b) { return rankOf(a) - rankOf(b); }
    }[state.sort];

    return list.sort(function (a, b) { return (by ? by(a, b) : 0) || a.pos - b.pos; });
  }

  /* ---------- Best selling ----------
     Shopify keeps a best-selling order for every collection, but the grid
     sorts in the browser, so it reads that order once: /collections/all by
     best-selling, from the slim data feed (a product's id and its place).
     Store-wide ranks give each collection and the search results the same
     relative order as Shopify's own. Unranked products go last. */
  var ranks = null;
  var ranksLoad = null;
  function rankOf(it) { return ranks && ranks.hasOwnProperty(it.id) ? ranks[it.id] : 1e9; }
  function loadRanks() {
    if (ranksLoad) return ranksLoad;
    var page = function (n) {
      return fetch('/collections/all?view=pfdata&sort_by=best-selling&page=' + n, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('ranks ' + r.status); return r.json(); });
    };
    ranksLoad = page(1).then(function (first) {
      var rest = [];
      for (var n = 2; n <= (first.pages || 1); n++) rest.push(page(n));
      return Promise.all(rest).then(function (others) {
        var map = {};
        [first].concat(others).forEach(function (p) {
          (p.items || []).forEach(function (d) { if (d && d.h && !map.hasOwnProperty(d.h)) map[d.h] = Object.keys(map).length; });
        });
        ranks = map;
      });
    });
    ranksLoad.catch(function () { ranksLoad = null; });
    return ranksLoad;
  }
  // Best selling needs the ranks first: pulse the grid, then show it.
  function sortReady() {
    if (state.sort !== 'bestselling' || ranks) return Promise.resolve();
    grid.classList.add('is-sorting');
    return loadRanks().catch(function () { ranks = {}; }).then(function () {
      if (cardsReady) grid.classList.remove('is-sorting');
    });
  }

  /* ---------- Rendering ---------- */

  function render(opts) {
    var list = filtered();
    var pages = Math.max(1, Math.ceil(list.length / perPage));
    if (state.page > pages) state.page = pages;

    var shown = loadMore
      ? list.slice(0, state.page * perPage)
      : list.slice((state.page - 1) * perPage, state.page * perPage);

    if (cardsReady) {
      var visible = {};
      shown.forEach(function (it) { visible[it.pos] = true; });
      items.forEach(function (it) { it.el.hidden = !visible[it.pos]; });

      // Move cards only when the visible order actually changes. Moving a card
      // disconnects and reconnects its components, so avoid it when possible.
      var current = $$('.wsbb-pf-item:not([hidden])', grid);
      var same = current.length === shown.length && shown.every(function (it, i) { return current[i] === it.el; });
      if (!same) shown.forEach(function (it) { grid.appendChild(it.el); });
    } else if (activeCount() || state.sort || state.page > 1) {
      // The sidebar is up but the cards aren't: the page's cards pulse until
      // they can show the result (settle() stops it).
      grid.classList.add('is-sorting');
    }

    var label = list.length + ' ' + (list.length === 1 ? 'product' : 'products');
    $('[data-pf-count]').textContent = label;
    $('[data-pf-result-count]').textContent = list.length;
    $('[data-pf-none]').hidden = list.length > 0;

    renderChips();
    renderPaging(list.length, pages, shown.length);
    syncCheckboxes();

    var badge = $('[data-pf-active-count]');
    var n = activeCount();
    badge.hidden = n === 0;
    badge.textContent = n;

    writeURL();
    if (opts && opts.scroll) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function renderPaging(total, pages, shownCount) {
    var nav = $('[data-pf-pages]');
    var more = $('[data-pf-more]');
    if (!cardsReady) return;

    if (loadMore) {
      nav.hidden = true;
      more.hidden = shownCount >= total;
      return;
    }

    more.hidden = true;
    nav.hidden = pages <= 1;
    if (pages <= 1) { nav.innerHTML = ''; return; }

    var p = state.page;
    var html = '';
    var btn = function (n, text, extra) {
      return '<button type="button" class="wsbb-pf__page' + (extra || '') + '" data-pf-page="' + n + '"' +
        (n === p ? ' aria-current="page"' : '') + '>' + text + '</button>';
    };
    if (p > 1) html += btn(p - 1, '&lsaquo; Prev', ' wsbb-pf__page--step');
    var last = 0;
    for (var i = 1; i <= pages; i++) {
      if (i === 1 || i === pages || Math.abs(i - p) <= 1) {
        if (last && i - last > 1) html += '<span class="wsbb-pf__gap">&hellip;</span>';
        html += btn(i, String(i));
        last = i;
      }
    }
    if (p < pages) html += btn(p + 1, 'Next &rsaquo;', ' wsbb-pf__page--step');
    nav.innerHTML = html;
  }

  function renderChips() {
    var box = $('[data-pf-chips]');
    var html = '';
    groups.forEach(function (g) {
      (state.checked[g.key] || []).forEach(function (name) {
        html += '<button type="button" class="wsbb-pf__chip" data-pf-uncheck="' + escapeAttr(g.key) +
          '" data-pf-value="' + escapeAttr(name) + '" aria-label="Remove ' + escapeAttr(name) + '">' +
          escapeHTML(name) + ' <span aria-hidden="true">&times;</span></button>';
      });
    });
    if (html) html += '<button type="button" class="wsbb-pf__link" data-pf-clear>Clear all</button>';
    box.innerHTML = html;
    box.hidden = !html;
  }

  // Swatch color for a Color option: the shared list first (snippets/wsbb-color,
  // for names CSS doesn't know), then the name as a CSS color ("Olive Drab" ->
  // olivedrab), then its last word ("Heather Grey" -> grey), as the theme's
  // product swatches do. Blank means a neutral dot.
  var COLORS = {};
  (config.colors || []).forEach(function (pair) { if (pair) COLORS[pair[0]] = pair[1]; });
  function cssColor(c) { return window.CSS && CSS.supports && CSS.supports('color', c) ? c : ''; }
  function colorFor(name) {
    var k = lower(name);
    return COLORS[k] || cssColor(k.replace(/\s+/g, '')) || cssColor(k.split(/\s+/).pop()) || '';
  }

  function renderGroups() {
    // "Filters open when the page loads" (Product filter groups section), counted
    // from the top; a group with an active selection opens regardless.
    var openCount = typeof config.open === 'number' ? config.open : 1;
    var html = groups.map(function (g, i) {
      var open = i < openCount || (state.checked[g.key] || []).length > 0;
      var opts = g.options.map(function (o) {
        var id = 'pf-' + slug(g.key) + '-' + slug(o.name);
        var input = '<input type="checkbox" class="wsbb-pf__input" id="' + id + '" data-pf-group="' +
          escapeAttr(g.key) + '" value="' + escapeAttr(o.name) + '">';
        if (g.kind === 'color') {
          // The theme's own swatch element, as on product cards, with the color's
          // name as visible text under it (WCAG 1.4.1: a color option can't be
          // told apart by its color alone; Nike's filter does the same). The
          // swatch must follow the checkbox inside the label: the theme's
          // selected ring is "input:checked ~ .element-swatch", and its hover
          // ring is "label:hover .element-swatch". The name is also the
          // checkbox's accessible name.
          var c = colorFor(o.name) || '#e5e5e5';
          return '<li><label class="wsbb-pf__opt--color">' + input +
            '<span class="element-swatch element-swatch--large" style="--element-swatch-color-background: ' + c + ';" aria-hidden="true"></span>' +
            '<span class="wsbb-pf__swatch-name">' + escapeHTML(o.name) + '</span></label></li>';
        }
        return '<li>' + input +
          '<label for="' + id + '" class="wsbb-pf__opt wsbb-pf__opt--' + g.kind + '">' +
          '<span>' + escapeHTML(o.name) + '</span></label></li>';
      }).join('');
      return '<details class="wsbb-pf__group"' + (open ? ' open' : '') + '><summary>' + escapeHTML(g.label) +
        '</summary><ul class="wsbb-pf__opts wsbb-pf__opts--' + g.kind + '">' + opts + '</ul></details>';
    }).join('');
    $('[data-pf-groups]').innerHTML = html;
  }

  function syncCheckboxes() {
    $$('[data-pf-group]').forEach(function (cb) {
      cb.checked = isChecked(cb.getAttribute('data-pf-group'), cb.value);
    });
  }

  function slug(s) { return lower(s).replace(/[^a-z0-9]+/g, '-'); }
  function escapeHTML(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  var escapeAttr = escapeHTML;

  /* ---------- Sticky sidebar offset ----------
     The site header is sticky and changes height as it compresses on
     scroll, so the sidebar's sticky top is measured from where the visible
     header actually ends, not a fixed value (a fixed 100px left the top
     filters under the 158px compressed header). This is the same
     measurement as the instant-search panel: the header row plus whichever
     sub-bar is showing. */
  function headerBottom() {
    var wrap = document.querySelector('#HeaderWrapper') || document.querySelector('.site-header');
    var bottom = wrap ? wrap.getBoundingClientRect().bottom : 0;
    document.querySelectorAll('.site-header__element--sub').forEach(function (bar) {
      var r = bar.getBoundingClientRect();
      var cs = getComputedStyle(bar);
      if (r.height > 0 && cs.visibility !== 'hidden' && cs.display !== 'none' && Number(cs.opacity) > 0) {
        bottom = Math.max(bottom, r.bottom);
      }
    });
    return Math.max(0, bottom);
  }

  var topPending = false;
  function setStickyTop() {
    topPending = false;
    root.style.setProperty('--pf-sticky-top', Math.round(headerBottom() + 16) + 'px');
  }
  function queueStickyTop() {
    if (topPending) return;
    topPending = true;
    requestAnimationFrame(setStickyTop);
  }
  setStickyTop();
  window.addEventListener('scroll', queueStickyTop, { passive: true });
  window.addEventListener('resize', queueStickyTop);
  document.addEventListener('headerStickyChange', function () { queueStickyTop(); setTimeout(queueStickyTop, 300); });

  /* ---------- Layout: sidebar, drawer, grid size ---------- */

  function applyLayout() {
    var isMobile = mobile.matches;
    var view;
    if (isMobile) {
      view = mobileCols === 1 ? '3-1' : 'medium';
    } else if (showFilters) {
      view = gridView;
    } else {
      view = gridView === 'small' ? 'xsmall' : 'small';
    }
    grid.setAttribute('data-view', view);

    if (isMobile) {
      root.classList.remove('wsbb-pf--filters-hidden');
      sidebar.classList.add('wsbb-pf__sidebar--drawer');
      toggleBtn.setAttribute('aria-expanded', sidebar.classList.contains('is-open') ? 'true' : 'false');
    } else {
      closeDrawer();
      sidebar.classList.remove('wsbb-pf__sidebar--drawer');
      root.classList.toggle('wsbb-pf--filters-hidden', !showFilters);
      toggleBtn.querySelector('[data-pf-toggle-label]').textContent = showFilters ? 'Hide filters' : 'Show filters';
      toggleBtn.setAttribute('aria-expanded', showFilters ? 'true' : 'false');
    }

    $$('[data-pf-view]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(Number(b.getAttribute('data-pf-view')) === mobileCols));
    });
  }

  var lastFocus = null;
  function openDrawer() {
    // Focus goes back to whatever opened the drawer; a tap on a phone
    // doesn't focus the button, so fall back to the Filter button itself.
    lastFocus = document.activeElement && document.activeElement !== document.body && document.activeElement.closest('button, a, input, select')
      ? document.activeElement.closest('button, a, input, select') : toggleBtn;
    sidebar.classList.add('is-open');
    overlay.hidden = false;
    document.documentElement.classList.add('wsbb-pf-lock');
    toggleBtn.setAttribute('aria-expanded', 'true');
    var close = $('.wsbb-pf__close', sidebar);
    if (close) close.focus();
  }

  function closeDrawer() {
    if (!sidebar.classList.contains('is-open')) return;
    sidebar.classList.remove('is-open');
    overlay.hidden = true;
    document.documentElement.classList.remove('wsbb-pf-lock');
    toggleBtn.setAttribute('aria-expanded', 'false');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* ---------- URL ---------- */

  function norm(s) { return lower(s).replace(/\+/g, '').trim(); }

  function readURL() {
    var params = new URLSearchParams(location.search);
    var f = params.get('filters');
    if (f) {
      f.split(';').forEach(function (part) {
        var at = part.indexOf(':');
        if (at < 0) return;
        var key = part.slice(0, at);
        var g = groups.filter(function (x) { return x.key === key; })[0];
        if (!g) return;
        part.slice(at + 1).split(',').forEach(function (want) {
          var w = g.key === 'Size' ? canonicalSize(want) : (g.kind === 'color' ? colorFamily(want) : want);
          var o = g.options.filter(function (x) { return norm(x.name) === norm(w); })[0];
          if (o && !isChecked(g.key, o.name)) (state.checked[g.key] = state.checked[g.key] || []).push(o.name);
        });
      });
    }
    var sort = params.get('sort');
    if (sort && sortSelect.querySelector('option[value="' + sort + '"]')) state.sort = sort;
    var page = parseInt(params.get('pagination') || params.get('page'), 10);
    if (page > 1) state.page = page;
  }

  function writeURL() {
    var url = new URL(location.href);
    var parts = [];
    groups.forEach(function (g) {
      var vals = state.checked[g.key] || [];
      if (vals.length) {
        parts.push(encodeURIComponent(g.key) + ':' + vals.map(encodeURIComponent).join(','));
      }
    });
    url.searchParams.delete('filters');
    url.searchParams.delete('sort');
    url.searchParams.delete('pagination');
    url.searchParams.delete('page');
    var qs = url.searchParams.toString();
    var extra = [];
    if (parts.length) extra.push('filters=' + parts.join(';'));
    if (state.sort) extra.push('sort=' + encodeURIComponent(state.sort));
    if (state.page > 1) extra.push('pagination=' + state.page);
    var search = [qs].concat(extra).filter(Boolean).join('&');
    setURL(url.pathname + (search ? '?' + search : '') + url.hash);
  }

  // Only touch the address bar when it would actually change, and never in the
  // theme editor: the editor watches its preview's URL and treats any rewrite,
  // even to the same address, as a redirect ("Page is redirecting to an
  // unsupported URL"). Filters still work there; they just aren't in the URL.
  function setURL(next) {
    if (window.Shopify && window.Shopify.designMode) return;
    if (next === location.pathname + location.search + location.hash) return;
    history.replaceState(history.state, '', next);
  }

  /* ---------- Events ---------- */

  function setChecked(groupKey, name, on) {
    var list = state.checked[groupKey] = state.checked[groupKey] || [];
    var i = list.indexOf(name);
    if (on && i < 0) list.push(name);
    if (!on && i > -1) list.splice(i, 1);
    if (!list.length) delete state.checked[groupKey];
    state.page = 1;
    stopInfinite();
    render();
  }

  function clearAll() {
    state.checked = {};
    state.page = 1;
    stopInfinite();
    render();
  }

  var observer = null;
  function startInfinite() {
    if (infinite || !('IntersectionObserver' in window)) return;
    infinite = true;
    observer = new IntersectionObserver(function (entries) {
      if (entries.some(function (e) { return e.isIntersecting; }) && !$('[data-pf-more]').hidden) {
        state.page += 1;
        render();
      }
    }, { rootMargin: '400px 0px' });
    observer.observe(moreBtn);
  }
  function stopInfinite() {
    if (observer) observer.disconnect();
    observer = null;
    infinite = false;
  }

  function bind() {
    root.addEventListener('change', function (e) {
      var cb = e.target.closest('[data-pf-group]');
      if (cb) setChecked(cb.getAttribute('data-pf-group'), cb.value, cb.checked);
    });

    root.addEventListener('click', function (e) {
      var t = e.target;
      var chip = t.closest('[data-pf-uncheck]');
      if (chip) { setChecked(chip.getAttribute('data-pf-uncheck'), chip.getAttribute('data-pf-value'), false); return; }
      if (t.closest('[data-pf-clear]')) { clearAll(); return; }
      var pageBtn = t.closest('[data-pf-page]');
      if (pageBtn) { state.page = Number(pageBtn.getAttribute('data-pf-page')); render({ scroll: true }); return; }
      if (t.closest('[data-pf-more-btn]')) { state.page += 1; render(); startInfinite(); return; }
      var view = t.closest('[data-pf-view]');
      if (view) { mobileCols = Number(view.getAttribute('data-pf-view')); writeStore('mobileGridSize', mobileCols); applyLayout(); return; }
      if (t.closest('[data-pf-close]')) { closeDrawer(); return; }
      if (t.closest('[data-pf-toggle]')) {
        if (mobile.matches) { openDrawer(); } else {
          showFilters = !showFilters;
          writeStore('showCategoryFilters', showFilters);
          applyLayout();
        }
      }
    });

    overlay.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

    sortSelect.addEventListener('change', function () {
      state.sort = sortSelect.value;
      state.page = 1;
      stopInfinite();
      sortReady().then(function () { render(); });
    });
    // Warm the best-selling ranks when the shopper reaches for the sort.
    ['pointerenter', 'focus', 'touchstart'].forEach(function (ev) {
      sortSelect.addEventListener(ev, function () { loadRanks().catch(function () {}); }, { once: true, passive: true });
    });

    if (mobile.addEventListener) mobile.addEventListener('change', applyLayout);
    else if (mobile.addListener) mobile.addListener(applyLayout);
  }

  /* ---------- Start ---------- */

  // Both feeds start at once. The sidebar waits only for the data; if that
  // feed fails, the data comes from the cards instead (as it used to).
  var cardsLoad = loadAll();
  var dataLoad = loadData().catch(function () {
    return cardsLoad.then(function (boxes) {
      return [].concat.apply([], boxes.map(function (box) { return $$('.wsbb-pf-item', box).map(dataOf); }));
    });
  });

  dataLoad.then(function (list) {
    list.forEach(function (d) {
      var it = toItem(d);
      if (!it || byPos[it.pos]) return;
      byPos[it.pos] = it;
      items.push(it);
    });
    announce(items.length);
    if (!items.length) { hideControls(); return; }

    groups = buildGroups();
    readURL();
    renderGroups();
    sortSelect.value = state.sort;

    toggleBtn.hidden = groups.length === 0;
    sidebar.hidden = groups.length === 0;
    root.classList.add('wsbb-pf--ready');

    bind();
    applyLayout();
    render();
    if (state.sort === 'bestselling') sortReady().then(function () { render(); });
    return cardsLoad.then(attachCards);
  }).catch(function () {
    // Back to the no-JS page: server-rendered cards and their ?page= links.
    if (cardsReady) return;
    hideControls();
    announce(null);
  });

  // Give each item its card. The server-rendered cards already on the page are
  // reused (same position), so the first page doesn't flash as it's swapped.
  function attachCards(boxes) {
    $$('.wsbb-pf-item', grid).forEach(function (el) {
      var d = dataOf(el);
      if (d && byPos[d.i || 0]) byPos[d.i || 0].el = el;
    });
    boxes.forEach(function (box) {
      $$('.wsbb-pf-item', box).forEach(function (el) {
        var d = dataOf(el);
        var it = d && byPos[d.i || 0];
        if (it && !it.el) it.el = el;
      });
    });
    // A product in one feed but not the other (changed between the two
    // requests) is left out rather than shown without a card.
    items = items.filter(function (it) { return it.el; });

    // Hidden until render() decides; appended in feed order.
    items.forEach(function (it) {
      if (it.el.parentNode !== grid) { it.el.hidden = true; grid.appendChild(it.el); }
    });

    var server = $('[data-pf-server-pagination]');
    if (server) server.hidden = true;
    cardsReady = true;
    render();
    settle();
  }

  // Placeholders out: skeleton cards (search) and the pulse over cards
  // waiting on URL state (collections). See wsbb-pf-shell.
  function settle() {
    $$('.wsbb-pf-skel', grid).forEach(function (el) { el.remove(); });
    var chips = $('[data-pf-chips]');
    chips.classList.remove('is-pending');
    if (!chips.innerHTML.trim()) chips.hidden = true;
    grid.classList.remove('is-sorting');
  }

  // The sidebar and toolbar render from the first paint (see wsbb-pf-shell).
  // Take them away again if there is nothing for them to do.
  function hideControls() {
    settle();
    sidebar.hidden = true;
    toggleBtn.hidden = true;
    $('[data-pf-sort-wrap]').hidden = true;
    $('[data-pf-views]').hidden = true;
  }

  // The search page counts its Products tab from this (null = feed failed).
  function announce(total) {
    window.wsbbPfTotal = total;  // for a listener that attaches after this fires
    document.dispatchEvent(new CustomEvent('wsbb:pf-ready', { detail: { total: total } }));
  }
})();
